import { base_colorContentBorder, white100 } from 'ext-ui/style/colors'
import styled, { css } from 'styled-components'

export const PositionedSidenav = styled.div<{ fixedElementPushdown: number }>`
  flex-direction: column;
  justify-content: space-between;

  position: fixed;
  left: 0;
  ${({ fixedElementPushdown }) => css`
    height: calc(100vh - ${fixedElementPushdown}px);
    top: ${fixedElementPushdown}px;
  `};

  background-color: ${white100};
  display: flex;
  width: 40px;
  z-index: 8;
  border-right: 1px solid ${base_colorContentBorder};
  padding-bottom: 12px;
`
